import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function ShowPlayers() {
  const getUsername = Cookies.get("username");
  const API_URL = BASE_URL + "/getplayers";
  const getRole = Cookies.get("user_role");
  const coachSportCategory = Cookies.get("sport_category"); 

  const [players, setPlayer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusLoading, setStatusLoading] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [derivedStats, setDerivedStats] = useState(null);

  useEffect(() => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const sortedPlayers = res.data.sort((a, b) => {
          const aTime = a.createdAt?._seconds || 0;
          const bTime = b.createdAt?._seconds || 0;
          return bTime - aTime;
        });
        setPlayer(sortedPlayers);
        setLoading(false);
      })
      .catch((error) => {
        console.log("There was an error", error);
        setLoading(false);
      });
  }, []);

  const handleStatusChange = async (playerId, newStatus) => {
    setStatusLoading((prev) => ({ ...prev, [playerId]: true }));
    try {
      await axios.post(
        `${BASE_URL}/addplayer`,
        { Id: playerId, Status: newStatus },
        { headers: { Authorization: apiKey, "Content-Type": "application/json" } }
      );

      setPlayer((prev) =>
        prev.map((p) => (p.Id === playerId ? { ...p, Status: newStatus } : p))
      );
      toast.success("Status updated successfully!");
    } catch (err) {
      console.error("Error updating status:", err);
      toast.error(
        err.response?.data?.message || "Failed to update status. Please try again."
      );
    } finally {
      setStatusLoading((prev) => ({ ...prev, [playerId]: false }));
    }
  };

  const handleViewDerivedStats = async (playerId) => {
    const player = players.find((p) => p.Id === playerId);
    const derived = player?.stats?.derived || {};

    if (!derived || Object.keys(derived).length === 0) {
      toast.info("Derived stats not found for this player.");
      return;
    }

    setDerivedStats(derived);
    setShowModal(true);
  };

  const searchTable = () => {
    const input = document.getElementById("search");
    const filter = input.value.toLowerCase();
    const rows = document.querySelectorAll("#Table tbody tr");

    rows.forEach((row) => {
      const match = [...row.getElementsByTagName("td")].some((cell) =>
        cell.textContent.toLowerCase().includes(filter)
      );
      row.style.display = match ? "" : "none";
    });
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <ToastContainer position="top-center" />
      <h2>All Players Details</h2>
      <br />
      <div className="row">
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control"
            id="search"
            placeholder="Search here..."
            onKeyUp={searchTable}
          />
        </div>
      </div>
      <br />
      <br />
      <table className="table table-striped table-light" id="Table">
        <thead>
          <tr>
            <th>Player Name</th>
            <th>Sports Category</th>
            <th>Event Name</th>
            <th>Event Date</th>
            <th>City / Location</th>
            <th>Email</th>
            <th>Jersey Number</th>
            <th>Status</th>
            <th style={{width: "205px"}}>Stats</th>
            <th>Created At</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {players
          .filter(player => {
            if (getRole === "Coach") {
              return player.SportCategory == coachSportCategory;
            }
            return true; // Admin sees all
          })
          .map((player) => {
            const createdAt = player.createdAt?._seconds
              ? new Date(player.createdAt._seconds * 1000).toLocaleString()
              : "N/A";

            const derived = player.stats?.derived || {};
            const hasDerived = Object.keys(derived).length > 0;

            return (
              <tr key={player.Id}>
                <td>
                  {player.EventCode == "NaN" || player.EventCode == null ? (
                    <span className="badge bg-secondary ms-2">Unofficial Entry</span>
                  ) : (
                    <span className="badge bg-success ms-2">Certified Athlete</span>
                  )}
                  {player.PlayerName}
                </td>
                <td>{player.SportCategory}</td>
                <td>{player.EventName}</td>
                <td>{player.EventDate}</td>
                <td>
                  {player.CityLocation && player.CityLocation.length > 20
                    ? player.CityLocation.substring(0, 20) + "..."
                    : player.CityLocation}
                </td>
                <td>{player.Email}</td>
                <td>{player.JerseyNumber}</td>
                <td style={{ width: "150px" }}>
                  {statusLoading[player.Id] ? (
                    <Loader />
                  ) : (
                    (() => {
                      const stats = player.stats?.official_stats || {};
                      const approveDisabled =
                        Object.keys(stats).length === 0 || Object.keys(derived).length === 0;

                      return (
                        <select
                          value={player.Status || "Pending"}
                          onChange={(e) => handleStatusChange(player.Id, e.target.value)}
                          className="form-select"
                          style={{
                            backgroundColor:
                              player.Status === "Approved"
                                ? "#d4edda"
                                : player.Status === "Rejected"
                                ? "#f8d7da"
                                : "#fff3cd",
                            color:
                              player.Status === "Approved"
                                ? "#155724"
                                : player.Status === "Rejected"
                                ? "#721c24"
                                : "#856404",
                            fontWeight: "bold",
                          }}
                        >
                          <option value="Pending">Pending</option>
                          <option value="Approved" disabled={approveDisabled}>
                            Approved
                          </option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      );
                    })()
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-dark btn-sm m-1"
                    onClick={() => handleViewDerivedStats(player.Id)}
                  >
                    Derived Stats
                  </button>
                  <Link to={`/stats/${player.Id}`}>
                    <button className="btn btn-primary btn-sm m-1">See Stats</button>
                  </Link>
                </td>
                <td>{createdAt}</td>
                <td>
                  <Link to={`/deleteplayer/${player.Id}`}>
                    <i className="bi bi-trash3 text-danger"></i>
                  </Link>
                </td>
              </tr>
            );
          })}
          {players.length === 0 && (
            <tr>
              <td colSpan="12" className="text-center">
                No records available to show.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Derived Stats Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Derived Stats</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {derivedStats ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Stat</th>
                  <th>Formula</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(derivedStats).map(([category, stats]) => {
                  // If stats is not an object, wrap it
                  const statsObj = typeof stats === "object" ? stats : { [category]: stats };
                  return Object.entries(statsObj).map(([stat, value]) => {
                    const formulas = {
                      avg: "h / ab",
                      obp: "(h + bb + hbp) / (ab + bb + hbp + sf)",
                      slg: "TB / ab",
                      era: "(er * 9) / ip",
                      whip: "(bb + h) / ip",
                      fpct: "(po + a) / (po + a + e)",
                      fg_pct: "fg_m / fg_a",
                      tp_pct: "tp_m / tp_a",
                      ft_pct: "ft_m / ft_a",
                      efficiency: "(pts + reb + ast + stl + blk - (fga - fg_m) - (fta - ft_m) - to)",
                      xp_pct: "xp_m / xp_a",
                      y_a: "yds / att",
                      gaa: "(ga * 60) / min",
                      sv_pct: "sv / sa",
                      fo_pct: "fo_w / (fo_w + fo_l)",
                      shot_acc: "sot / shots"
                    };
                    const formula = formulas[stat.toLowerCase()] || "—";
                    return (
                      <tr key={`${category}-${stat}`}>
                        <td>{category.toUpperCase()}</td>
                        <td>{stat.toUpperCase()}</td>
                        <td>{formula}</td>
                        <td>{value}</td>
                      </tr>
                    );
                  });
                })}
              </tbody>
            </table>
          ) : (
            <p className="text-center text-muted">Derived stats not found.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
